import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import stageChart from './stageChart';
import statusChart from './statusChart';
import { salesStatuslist, attractStatuslist } from '@/api/PMS/customerService/analyticStatistics.js';
export default {
  components: {
    stageChart: stageChart,
    statusChart: statusChart
  },
  data: function data() {
    return {
      listQuery: {},
      dates: [],
      chartData1: [],
      lendName1: [],
      chartData2: [],
      lendName2: [],
      total: 0
    };
  },
  created: function created() {
    this.handleFilter();
  },
  methods: {
    handleFilter: function handleFilter() {
      var _this = this;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      salesStatuslist(this.listQuery).then(function (response) {
        _this.chartData1 = [];
        _this.lendName1 = [];
        response.data.data.forEach(function (element) {
          _this.chartData1.push({
            value: element.number,
            name: element.dicName
          });

          _this.lendName1.push(element.dicName);
        });
      });
      attractStatuslist(this.listQuery).then(function (response) {
        _this.total = response.data.data.totalNumber;
        _this.chartData2 = [];
        _this.lendName2 = [];
        response.data.data.detailList.forEach(function (element) {
          _this.chartData2.push(element.number);

          _this.lendName2.push(element.dicName);
        });
      });
    }
  }
};